export enum ContentTypesEnum {
  genericFooter = 'genericFooter',
  ordermanagerPriceDisclaimer = 'ordermanagerPriceDisclaimer',
  login = 'login',
  genericError = 'genericError',
  myFfExtrasPage = 'myFfExtrasPage',
  passengerChange = 'passengerChange',
  finalizeOrder = 'finalizeOrder',
  splitPnr = 'splitPnr',
  cancelOrder = 'cancelOrder',
  orderPage = 'orderPage',
  flightDetailsModal = 'flightDetailsModal',
  flightOverview = 'flightOverview',
  actionModal = 'actionModal',
}

export type ContentTypesEnumType = keyof typeof ContentTypesEnum;
